import { render, staticRenderFns } from "./PublicPostList.vue?vue&type=template&id=7fde1200&scoped=true&"
import script from "./PublicPostList.vue?vue&type=script&lang=js&"
export * from "./PublicPostList.vue?vue&type=script&lang=js&"
import style0 from "./PublicPostList.vue?vue&type=style&index=0&id=7fde1200&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fde1200",
  null
  
)

export default component.exports